import React from "react";
import { useLocation } from "react-router-dom";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

const routeTitles = [
  { match: /^\/$/, title: "Dashboard", icon: DashboardOutlinedIcon },
  {
    match: /^\/ip-census-management/,
    title: "Dashboard",
    icon: DashboardOutlinedIcon,
  },
  { match: /^\/members\/full-list/, title: "Members", icon: DashboardOutlinedIcon },
  { match: /^\/members\/ip-census/, title: "IP Census", icon: DashboardOutlinedIcon },
  {
    match: /^\/members\/face-sheet/,
    title: "Face Sheet",
    icon: DashboardOutlinedIcon,
  },
];

const Topbar = () => {
  const { pathname } = useLocation();
  const route =
    routeTitles.find((r) => r.match.test(pathname)) || routeTitles[0];
  const Icon = route.icon;

  return (
    <header className="topbar">
      <div className="topbar__breadcrumb">
        <Icon fontSize="small" />
        <span className="crumb-active">{route.title}</span>
      </div>
      <div className="topbar__spacer" />
      <button type="button" className="topbar__icon-btn" title="Help">
        <HelpOutlineOutlinedIcon fontSize="small" />
      </button>
      <button type="button" className="topbar__icon-btn" title="Notifications">
        <NotificationsOutlinedIcon fontSize="small" />
        <span className="dot" />
      </button>
    </header>
  );
};

export default Topbar;
